module.exports = __webpack_public_path__ + "media/images/mobile/city_img/j-f6bf40870f73b0ab8c788893e0e66ed7.jpg";